import React, {FC, memo, ReactNode} from "react";
import classNames from "classnames";
import css from "./FeatureWrapper.less";

type FeatureWrapperProps = {
    title?: string;
    children?: ReactNode;
    width?: number;
    paddingTop?: number;
    height?: number;
};

const FeatureWrapper: FC<FeatureWrapperProps> = ({
    title,
    children,
    width = 900,
    paddingTop = 0,
    height,
}) => {
    return (
        <div
            className={classNames(css.root, css.pageContainer)}
            style={{paddingTop, minHeight: height}}
        >
            {title && (
                <div className={css.title} style={{width}}>
                    {title}
                </div>
            )}
            <div className={css.content} style={{maxWidth: width}}>
                {children}
            </div>
        </div>
    );
};

export default memo(FeatureWrapper);
